import { api } from "../api";

/**
 * ticketTypesFindAllByActivated - Function that finds on database all tickets types
 * /tickets/types 
 * method GET 
 * @async-function
 */
const ticketTypesFindAllByActivated = async (token: string, status: string) => {
    const response = await api.get(
        `/tickets/types/${status}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default ticketTypesFindAllByActivated;